import { render, staticRenderFns } from "./BlogFooter.vue?vue&type=template&id=7d4628a8&"
import script from "./BlogFooter.vue?vue&type=script&lang=js&"
export * from "./BlogFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports